import { create } from 'zustand';
import type { InAppNotification } from '../types/ui/inAppNotification';

interface NotificationWithId extends InAppNotification {
  readonly id: string;
}

interface NotificationStore {
  notifications: NotificationWithId[];
  showNotification: (notification: InAppNotification) => () => void;
  hideNotification: (id: string) => void;
}

let notificationIdCounter = 0;

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],

  showNotification: (notification: InAppNotification) => {
    const id = `notification-${++notificationIdCounter}-${Date.now()}`;
    const notificationWithId: NotificationWithId = { ...notification, id };

    set((state) => ({
      notifications: [...state.notifications, notificationWithId]
    }));

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    // Auto-hide after duration if specified
    if (notification.durationMs) {
      timeoutId = setTimeout(() => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id)
        }));
      }, notification.durationMs);
    }

    // Return callback to manually hide
    return () => {
      // Clear timeout if it exists
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id)
      }));
    };
  },

  hideNotification: (id: string) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id)
    }));
  }
}));
